import type { Definition } from '~/types'

export const PageNewsletter: Definition = {
  contentType: 'PageNewsletter',
  fields: [
    {
      id: 'icon',
      name: 'Icon',
      type: 'Symbol'
    },
    {
      id: 'description',
      name: 'Description',
      type: 'RichText'
    },
    {
      id: 'informationLink',
      name: 'Information Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'formTitle',
      name: 'Form Title',
      type: 'Symbol'
    },
    {
      id: 'formId',
      name: 'Form ID',
      type: 'Symbol'
    },
    {
      id: 'formThankYouTitle',
      name: 'Form Thank You Title',
      type: 'Symbol'
    },
    {
      id: 'formThankYouDescription',
      name: 'Form Thank You Description',
      type: 'Symbol'
    },
    {
      id: 'stepsFormEnabled',
      name: 'Steps Form Enabled',
      type: 'Boolean'
    },
    {
      id: 'relatedContent',
      name: 'Related Content',
      type: 'BlockRelatedContent'
    }
  ]
}

export const PageNewsletterDetail: Definition = {
  contentType: 'PageNewsletterDetail',
  fields: [
    {
      id: 'icon',
      name: 'Icon',
      type: 'Symbol'
    },
    {
      id: 'description',
      name: 'Description',
      type: 'RichText'
    },
    {
      id: 'informationLink',
      name: 'Information Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'formTitle',
      name: 'Form Title',
      type: 'Symbol'
    },
    {
      id: 'formId',
      name: 'Form ID',
      type: 'Symbol'
    },
    {
      id: 'formThankYouTitle',
      name: 'Form Thank You Title',
      type: 'Symbol'
    },
    {
      id: 'formThankYouDescription',
      name: 'Form Thank You Description',
      type: 'Symbol'
    },
    {
      id: 'stepsFormEnabled',
      name: 'Steps Form Enabled',
      type: 'Boolean'
    },
    {
      id: 'relatedContent',
      name: 'Related Content',
      type: 'BlockRelatedContent'
    }
  ]
}

export default {
  PageNewsletter,
  PageNewsletterDetail
}
